<template>

    <div v-show="show">

        <div class="fullscreen overlay overlay-transition"
             @click.self="closeChildModal">


            <transition name="modaliscomming">

                <div v-show="showTransition" class="modal-container" :class="{'navigation-padding': isNavigationOpen}" @click.self="closeChildModal">

                    <div class="modal">

                        <slot></slot>

                    </div>

                </div>

            </transition>

        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

export default {

    name: 'modal',

    props: {
        show: {
            type: Boolean,
            default: false
        }
    },

    watch: {

        show (bool) {
            setTimeout(() => {
                this.showTransition = bool
            }, 20)
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'isNavigationOpen'
        ])

    },

    data() {
        return {
            showTransition: false
        }
    },

    methods: {

        closeChildModal() {
            this.$emit('closeModal')
        }
    }

}

</script>

<style lang="scss" scoped>

.overlay {
    display: flex;
    z-index: 2;
    flex-direction: row;
    justify-content: center;
    overflow: hidden;
    width: 100%;
    height: 100%;
    transition: background-color 300ms ease-in-out;
    @media screen and (min-width: $above-tablet-length) {
        align-items: center;
    }
}

.overlay-transition {
    background-color: rgba(0, 0, 0, 0.5);
    transition: background-color 300ms ease-in-out;
}

.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    position: relative;
    background-color: $white;
    min-height: 50px;
    border-radius: 12px;
    box-shadow: 0 14px 23px 14px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 16px;
    &:lang(ar-sa) {
        direction: rtl;
    }
}

.navigation-padding {
    @media screen and (min-width: $above-tablet-length) {
        padding-left: 320px;
    }
}

/*animation*/


.modaliscomming-enter-active {
    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.modaliscomming-leave-active {
    transition: 0.2s cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.modaliscomming-enter {
    opacity: 0;
}

.modaliscomming-leave-to {
    opacity: 0;
}

</style>
